const menuItemPosition = window.SIGO_DATA['menuItemPosition'];

if (menuItemPosition) {
    setTimeout(() => {
        let allMenuItems = document.querySelectorAll("[data-scroll-nav]");

        allMenuItems.forEach(menuItem => {
            menuItem.classList.remove('active');
        });

        let menuItem = document.querySelector("[data-scroll-nav='" + menuItemPosition + "']");
        menuItem.classList.add('active');

    }, 100);
}

const htmlLocale = document.getElementsByTagName('html')[0].getAttribute('lang');

window.PortalWeb = {};
PortalWeb.changeLaguage = function (locale) {
    const urlHasLocaleAndHome = window.location.href === `${window.location.origin}/${htmlLocale}`;
    let pathname = '';

    if (!urlHasLocaleAndHome) {
        let urlHasLocale = window.location.href.split(`${window.location.origin}/${htmlLocale}/`).length > 1;
        pathname = urlHasLocale ? window.location.pathname.split(`/${htmlLocale}/`)[1] : window.location.pathname.substring(1);
    }

    let url = `${window.location.origin}/${locale}/${pathname}${window.location.hash}`;

    if (url.lastIndexOf('/') === (url.length - 1))
        url = url.substring(0, url.length - 1);

    window.location.replace(url);
};